import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "file-video-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.3607 9.67287C10.7485 9.45152 11.2252 9.45519 11.6095 9.68249L14.1581 11.1898C14.5356 11.4137 14.7678 11.8205 14.7678 12.2594C14.7678 12.6982 14.5364 13.1046 14.1589 13.3284L11.6095 14.8362C11.2252 15.0635 10.7485 15.0672 10.3607 14.8459C9.97314 14.6246 9.73398 14.2122 9.73413 13.7659V10.7525C9.73398 10.3062 9.97313 9.89413 10.3607 9.67287ZM11.2341 11.2032L13.0199 12.2594L11.2341 13.3155V11.2032Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7 2.25C5.48079 2.25 4.25 3.48079 4.25 5V19C4.25 20.5192 5.48079 21.75 7 21.75H17C18.5192 21.75 19.75 20.5192 19.75 19V7.828C19.75 7.09886 19.4598 6.39916 18.9443 5.88367L16.1163 3.05567C15.6008 2.54018 14.9011 2.25 14.172 2.25H7ZM5.75 5C5.75 4.30921 6.30921 3.75 7 3.75H14.172C14.5029 3.75 14.8212 3.88182 15.0557 4.11633L17.8837 6.94433C18.1182 7.17884 18.25 7.49714 18.25 7.828V19C18.25 19.6908 17.6908 20.25 17 20.25H7C6.30921 20.25 5.75 19.6908 5.75 19V5Z"
    }, null, -1)
  ])))
}
export default { render: render }